import { countries, services } from './constants.js';

export default drcStore = {
    countryNames: countries.map(country => country.name),
    selectedCountryName: '',
    services: [],

    updateUrls() {
        const getCountryCode = (country, service) => {
            if (service.name === 'DAX Core Streaming' && country.name === 'United Kingdom') {
                return 'uk';
            }
            return country.code;
        }

        const selectedCountry = countries.find(country => country.name === this.selectedCountryName);
        this.services = services
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(s => {
                const countryCode = getCountryCode(selectedCountry, s);
                return {
                    ...s,
                    url: s.url.replace('{0}', countryCode)
                }
            });
    },
};